import { Radio, RadioGroup, Tooltip, Whisper } from 'rsuite';
import infoIcon from '../../../../../../assets/icons/icon_info_gray.svg';
import styles from './PriceTypeFilter.module.scss';
import { PRICE_TYPE_FILTER_OPTIONS } from '../../data';

type PriceTypeFilterProps = {
  priceFilter: string;
  onChange: (value: string) => void;
};

export const PriceTypeFilter = ({ priceFilter, onChange }: PriceTypeFilterProps) => {
  return (
    <RadioGroup className="tipo-oferta" inline name="priceFilter" value={priceFilter} onChange={onChange}>
      {PRICE_TYPE_FILTER_OPTIONS.map(item => (
        <Radio id={item.id} key={item.id} value={item.value}>
          {item.label}
          <span className={styles['price-type-info-icon']}>
            <Whisper placement="bottom" trigger="hover" speaker={<Tooltip>{item.tooltip}</Tooltip>}>
              <img src={infoIcon} alt="" />
            </Whisper>
          </span>
        </Radio>
      ))}
    </RadioGroup>
  );
};
